// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + {"263":"CartPage","754":"NotFoundPage","968":"DetailInfoPage"}[chunkId] + "." + {"263":"c8967cf5","754":"0be5dca2","968":"ff5c1fc9"}[chunkId] + ".chunk.js";
};